var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPermissionLevel6 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7593 5.4306L11.7633 3.03064C11.6431 2.98979 11.5143 2.98979 11.3942 3.03064L4.39821 5.4306C4.16032 5.51283 4 5.74145 4 6.00005V12C4 18.5937 11.3358 20.9512 11.4104 20.9748C11.4652 20.9916 11.5218 21 11.5789 21C11.6361 21 11.6927 20.9916 11.7475 20.9748C11.822 20.9514 19.1579 18.594 19.1579 12V6.00005C19.1579 5.74143 18.9977 5.51282 18.7593 5.4306Z",
    fill: "#4E78D6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6259 15.75C13.2403 15.75 14.4238 14.6651 14.4238 13.1546V13.1442C14.4238 11.7374 13.4116 10.6993 11.9685 10.6993C10.9511 10.6993 10.2036 11.2184 9.90771 11.9035H9.88176C9.88176 11.8205 9.88176 11.7426 9.88695 11.6648C9.93886 10.2477 10.4424 9.09528 11.6467 9.09528C12.3163 9.09528 12.7783 9.4275 12.9755 9.94139L12.9963 9.98811H14.3252L14.3148 9.93101C14.076 8.7994 13.043 8 11.657 8C9.7468 8 8.59961 9.4794 8.59961 11.9555V11.9658C8.59961 14.5924 9.97 15.75 11.6259 15.75ZM10.1102 13.1753V13.1701C10.1102 12.3344 10.7642 11.7323 11.6207 11.7323C12.4772 11.7323 13.1053 12.3396 13.1053 13.1909V13.2013C13.1053 14.0111 12.4409 14.6547 11.6051 14.6547C10.7694 14.6547 10.1102 14.0059 10.1102 13.1753Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPermissionLevel6);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_permission_level_6.79c6ca50f1e94274b59a3566ca5e872f.svg";